var render = function() {
  var _obj
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "calendar__unit-wrap",
      class: {
        "is-hoverable": _vm.is.hoverable,
        "is-product": _vm.is.product,
        "is-group": _vm.is.group,
        "is-empty": _vm.is.empty,
        "is-active":
          _vm.selected.alternative || _vm.selected.product || _vm.selected.group
      },
      on: {
        mouseleave: _vm.deselect,
        mouseenter: function($event) {
          return _vm.select(false)
        }
      }
    },
    [
      _c(
        "div",
        {
          staticClass: "calendar__unit",
          style: {
            "background-color": _vm.is.group
              ? _vm.cell.product_group.preview_color
              : "#fbe2a9"
          }
        },
        [
          _vm.cell
            ? [
                _c(
                  "div",
                  {
                    staticClass: "calendar__picture",
                    on: {
                      click: function($event) {
                        $event.preventDefault()
                        $event.stopPropagation()
                        return _vm.select(true)
                      }
                    }
                  },
                  [
                    _vm.is.product
                      ? _c("img", {
                          attrs: { src: _vm.cell.product.small_image }
                        })
                      : _vm._e(),
                    _vm.is.group
                      ? _c("img", {
                          attrs: { src: _vm.cell.product_group.image }
                        })
                      : _vm._e(),
                    _vm.is.empty
                      ? _c("img", {
                          attrs: { src: "/static/images/qwestion.png" }
                        })
                      : _vm._e()
                  ]
                ),
                _vm.is.group
                  ? _c("div", {
                      staticClass: "calendar__food",
                      domProps: {
                        textContent: _vm._s(_vm.cell.product_group.name)
                      },
                      on: {
                        click: function($event) {
                          $event.preventDefault()
                          $event.stopPropagation()
                          return _vm.select($event)
                        }
                      }
                    })
                  : _vm._e(),
                _c("div", {
                  staticClass: "calendar__icon",
                  class:
                    ((_obj = {}),
                    (_obj["calendar__icon--" + _vm.reaction] =
                      typeof _vm.reaction !== "undefined"),
                    _obj)
                }),
                _vm.is.product
                  ? _c(
                      "div",
                      {
                        staticClass: "calendar__hover",
                        on: {
                          click: function($event) {
                            $event.stopPropagation()
                          }
                        }
                      },
                      [
                        _c("div", { staticClass: "calendar__icons" }, [
                          _c(
                            "a",
                            {
                              staticClass: "calendar__icons--type img",
                              class: { "is-current": _vm.reaction == 1 },
                              attrs: { href: "#" },
                              on: {
                                click: function($event) {
                                  $event.preventDefault()
                                  $event.stopPropagation()
                                  return _vm.confirmOpen("like")
                                }
                              }
                            },
                            [
                              _c("img", {
                                attrs: { src: "/static/images/ic1.png" }
                              })
                            ]
                          ),
                          _c(
                            "a",
                            {
                              staticClass: "calendar__icons--type img",
                              class: { "is-current": _vm.reaction == 2 },
                              attrs: { href: "#" },
                              on: {
                                click: function($event) {
                                  $event.preventDefault()
                                  $event.stopPropagation()
                                  return _vm.confirmOpen("dislike")
                                }
                              }
                            },
                            [
                              _c("img", {
                                attrs: { src: "/static/images/ic2.png" }
                              })
                            ]
                          ),
                          _c(
                            "a",
                            {
                              staticClass: "calendar__icons--type img",
                              class: { "is-current": _vm.reaction == 3 },
                              attrs: { href: "#" },
                              on: {
                                click: function($event) {
                                  $event.preventDefault()
                                  $event.stopPropagation()
                                  return _vm.confirmOpen("allergic")
                                }
                              }
                            },
                            [
                              _c("img", {
                                attrs: { src: "/static/images/ic3.png" }
                              })
                            ]
                          )
                        ])
                      ]
                    )
                  : _vm._e(),
                _vm.is.product && _vm.selected.alternative
                  ? _c(
                      "div",
                      {
                        staticClass: "calendar__hover-half",
                        class: {
                          "is-active":
                            _vm.selected.alternative &&
                            (_vm.isLoading || _vm.alternatives.length > 0)
                        },
                        on: {
                          click: function($event) {
                            $event.stopPropagation()
                          }
                        }
                      },
                      [
                        _c(
                          "div",
                          { staticClass: "calendar__hover-top" },
                          [
                            _vm.isLoading
                              ? _c("loading")
                              : _c(
                                  "slider",
                                  {
                                    staticClass: "calendar__slider",
                                    attrs: {
                                      options: {
                                        prevButton: ".category__nav--prev",
                                        nextButton: ".category__nav--next"
                                      }
                                    }
                                  },
                                  [
                                    _vm._l(_vm.alternatives, function(
                                      alternative
                                    ) {
                                      return _c(
                                        "swiper-slide",
                                        {
                                          key: alternative.id,
                                          staticClass: "calendar__slide"
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass: "calendar__img img",
                                              on: {
                                                click: function($event) {
                                                  $event.preventDefault()
                                                  return _vm.setProduct(
                                                    alternative
                                                  )
                                                }
                                              }
                                            },
                                            [
                                              _c("img", {
                                                staticStyle: {
                                                  "max-height": "65px"
                                                },
                                                attrs: {
                                                  src: alternative.small_image
                                                }
                                              })
                                            ]
                                          )
                                        ]
                                      )
                                    }),
                                    _c("div", {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value: _vm.alternatives.length > 0,
                                          expression: "alternatives.length > 0"
                                        }
                                      ],
                                      staticClass:
                                        "category__nav category__nav--prev icon-left",
                                      attrs: { slot: "button-next" },
                                      slot: "button-next"
                                    }),
                                    _c("div", {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value: _vm.alternatives.length > 0,
                                          expression: "alternatives.length > 0"
                                        }
                                      ],
                                      staticClass:
                                        "category__nav category__nav--next icon-right",
                                      attrs: { slot: "button-prev" },
                                      slot: "button-prev"
                                    })
                                  ],
                                  2
                                )
                          ],
                          1
                        )
                      ]
                    )
                  : _vm._e(),
                _vm.is.product && _vm.selected.alternative
                  ? _c(
                      "div",
                      {
                        staticClass: "zoom",
                        class: { "is-active": _vm.selected.alternative },
                        on: {
                          click: function($event) {
                            $event.stopPropagation()
                          }
                        }
                      },
                      [
                        _c("div", { staticClass: "zoom__arrow" }),
                        _c("div", { staticClass: "zoom__block" }, [
                          _c("div", { staticClass: "zoom__picture img" }, [
                            _c("img", {
                              attrs: { src: _vm.cell.product.small_image }
                            })
                          ])
                        ]),
                        _c("div", { staticClass: "zoom__icons" }, [
                          _c("a", {
                            staticClass: "zoom__icon zoom__icon--1",
                            class: { "is-active": _vm.reaction === 1 },
                            attrs: { href: "#" },
                            on: {
                              click: function($event) {
                                $event.preventDefault()
                                $event.stopPropagation()
                                return _vm.confirmOpen("like")
                              }
                            }
                          }),
                          _c("a", {
                            staticClass: "zoom__icon zoom__icon--2",
                            class: { "is-active": _vm.reaction === 2 },
                            attrs: { href: "#" },
                            on: {
                              click: function($event) {
                                $event.preventDefault()
                                $event.stopPropagation()
                                return _vm.confirmOpen("dislike")
                              }
                            }
                          }),
                          _c("a", {
                            staticClass: "zoom__icon zoom__icon--3",
                            class: { "is-active": _vm.reaction === 3 },
                            attrs: { href: "#" },
                            on: {
                              click: function($event) {
                                $event.preventDefault()
                                $event.stopPropagation()
                                return _vm.confirmOpen("allergic")
                              }
                            }
                          })
                        ])
                      ]
                    )
                  : _vm._e(),
                _vm.selected.product
                  ? _c(
                      "div",
                      {
                        staticClass: "half half--products",
                        class: {
                          "is-active":
                            _vm.selected.product &&
                            (_vm.isLoading || _vm.variants.length > 0)
                        },
                        staticStyle: {
                          position: "absolute",
                          top: "100%",
                          left: "50%",
                          transform: "translateX(-50%)",
                          "z-index": "1000"
                        },
                        on: {
                          click: function($event) {
                            $event.stopPropagation()
                          }
                        }
                      },
                      [
                        _c("div", { staticClass: "half__arrow" }),
                        _c(
                          "div",
                          { staticClass: "half__drop-slider" },
                          [
                            _vm.isLoading
                              ? _c("loading")
                              : _c(
                                  "div",
                                  {
                                    style: {
                                      width:
                                        (_vm.variants.length > 3
                                          ? 3
                                          : _vm.variants.length) *
                                          75 +
                                        "px"
                                    }
                                  },
                                  [
                                    _c(
                                      "slider",
                                      {
                                        staticClass: "calendar__slider",
                                        attrs: {
                                          options: {
                                            slidesPerView:
                                              _vm.variants.length > 3
                                                ? 3
                                                : _vm.variants.length,
                                            prevButton: ".category__nav--prev",
                                            nextButton: ".category__nav--next"
                                          }
                                        }
                                      },
                                      [
                                        _vm._l(_vm.variants, function(variant) {
                                          return _c(
                                            "swiper-slide",
                                            {
                                              key: variant.id,
                                              staticClass: "half__drop-slide"
                                            },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "half__product center",
                                                  on: {
                                                    click: function($event) {
                                                      $event.preventDefault()
                                                      return _vm.setProduct(
                                                        variant
                                                      )
                                                    }
                                                  }
                                                },
                                                [
                                                  _c("img", {
                                                    attrs: {
                                                      src: variant.small_image
                                                    }
                                                  })
                                                ]
                                              ),
                                              _c("div", {
                                                staticClass: "half__drop-name",
                                                domProps: {
                                                  textContent: _vm._s(
                                                    variant.name
                                                  )
                                                }
                                              })
                                            ]
                                          )
                                        }),
                                        _c("div", {
                                          directives: [
                                            {
                                              name: "show",
                                              rawName: "v-show",
                                              value: _vm.variants.length > 0,
                                              expression: "variants.length > 0"
                                            }
                                          ],
                                          staticClass:
                                            "half__nav half__nav--prev icon-left",
                                          attrs: { slot: "button-next" },
                                          slot: "button-next"
                                        }),
                                        _c("div", {
                                          directives: [
                                            {
                                              name: "show",
                                              rawName: "v-show",
                                              value: _vm.variants.length > 0,
                                              expression: "variants.length > 0"
                                            }
                                          ],
                                          staticClass:
                                            "half__nav half__nav--next icon-right",
                                          attrs: { slot: "button-prev" },
                                          slot: "button-prev"
                                        })
                                      ],
                                      2
                                    )
                                  ],
                                  1
                                )
                          ],
                          1
                        )
                      ]
                    )
                  : _vm._e(),
                _vm.selected.group
                  ? _c(
                      "div",
                      {
                        staticClass: "half half--group",
                        class: {
                          "is-active":
                            _vm.selected.group &&
                            (_vm.isLoading || _vm.variants.length > 0)
                        },
                        staticStyle: {
                          position: "absolute",
                          top: "100%",
                          left: "50%",
                          transform: "translateX(-50%)",
                          "z-index": "1000"
                        },
                        on: {
                          click: function($event) {
                            $event.stopPropagation()
                          }
                        }
                      },
                      [
                        _c("div", { staticClass: "half__arrow" }),
                        _c(
                          "div",
                          { staticClass: "half__group clearfix" },
                          [
                            _vm.isLoading
                              ? _c("loading")
                              : _vm._l(_vm.variants, function(group) {
                                  return _c(
                                    "a",
                                    {
                                      staticClass: "half__group-block",
                                      attrs: { href: "#" },
                                      on: {
                                        click: function($event) {
                                          $event.preventDefault()
                                          return _vm.setGroup(group)
                                        }
                                      }
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "half__drop-picture center",
                                          style: {
                                            "background-color":
                                              group.preview_color
                                          }
                                        },
                                        [
                                          _c("img", {
                                            attrs: { src: group.image }
                                          })
                                        ]
                                      ),
                                      _c("div", {
                                        staticClass: "half__drop-name",
                                        domProps: {
                                          textContent: _vm._s(group.name)
                                        }
                                      })
                                    ]
                                  )
                                })
                          ],
                          2
                        )
                      ]
                    )
                  : _vm._e()
              ]
            : _vm._e()
        ],
        2
      ),
      _vm.is.product
        ? _c(
            "custom-modal",
            {
              ref: "confirm",
              attrs: { title: _vm.confirmTitle, dismissible: false },
              on: {
                click: function($event) {
                  $event.preventDefault()
                  $event.stopPropagation()
                }
              }
            },
            [
              _vm.isLoading
                ? _c("loading")
                : _c("div", { staticClass: "modal__picture img" }, [
                    _c("img", {
                      attrs: {
                        src: _vm.cell.replaced_product
                          ? _vm.cell.replaced_product.large_image ||
                            _vm.cell.replaced_product.small_image
                          : _vm.cell.product.large_image ||
                            _vm.cell.product.small_image
                      }
                    }),
                    _c("div", {
                      staticClass: "modal__icon",
                      class: _vm.confirmIcon
                    })
                  ]),
              _c("template", { slot: "footer" }, [
                _c("div", { staticClass: "modal__part" }, [
                  _c("button", {
                    staticClass: "calendar__link modal__link2",
                    attrs: { disabled: _vm.isLoading },
                    domProps: { textContent: _vm._s(_vm.i18n.yes) },
                    on: {
                      click: function($event) {
                        $event.preventDefault()
                        return _vm.confirmSucceed()
                      }
                    }
                  }),
                  _c("button", {
                    staticClass: "calendar__link modal__link2",
                    attrs: { disabled: _vm.isLoading },
                    domProps: { textContent: _vm._s(_vm.i18n.no) },
                    on: {
                      click: function($event) {
                        $event.preventDefault()
                        return _vm.confirmClose()
                      }
                    }
                  })
                ])
              ])
            ],
            2
          )
        : _vm._e(),
      _c(
        "custom-modal",
        { ref: "replaceAlternatives" },
        [
          _c("div", {
            ref: "clickhunter",
            staticClass: "calendar__title modal__title modal__title--2",
            domProps: {
              textContent: _vm._s(
                _vm.variants.length == 0 && !_vm.isLoading
                  ? _vm.i18n.noReplaceAlternative
                  : _vm.i18n.chooseReplaceAlternative
              )
            }
          }),
          _c(
            "div",
            {
              on: {
                click: function($event) {
                  $event.preventDefault()
                  $event.stopPropagation()
                }
              }
            },
            [
              _vm.isLoading
                ? _c("loading")
                : _vm.variants.length > 0
                ? _c(
                    "div",
                    [
                      _c(
                        "slider",
                        {
                          staticClass: "calendar__slider",
                          attrs: {
                            options: {
                              slidesPerView: 4,
                              prevButton: ".half__nav--prev",
                              nextButton: ".half__nav--next"
                            }
                          }
                        },
                        [
                          _vm._l(_vm.variants, function(product) {
                            return _c("swiper-slide", { key: product.id }, [
                              _c(
                                "a",
                                {
                                  staticClass: "half__drop-slide",
                                  attrs: { href: "#" },
                                  on: {
                                    click: function($event) {
                                      $event.preventDefault()
                                      return _vm.setReplace(product.id)
                                    }
                                  }
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "half__product center",
                                      class: {
                                        "is-active": _vm.replace == product.id
                                      }
                                    },
                                    [
                                      _c("img", {
                                        attrs: { src: product.small_image }
                                      })
                                    ]
                                  ),
                                  _c("div", {
                                    staticClass: "half__drop-name",
                                    domProps: {
                                      textContent: _vm._s(product.name)
                                    }
                                  })
                                ]
                              )
                            ])
                          }),
                          _c("div", {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.variants.length > 0,
                                expression: "variants.length > 0"
                              }
                            ],
                            staticClass: "half__nav half__nav--prev icon-left",
                            attrs: { slot: "button-next" },
                            slot: "button-next"
                          }),
                          _c("div", {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.variants.length > 0,
                                expression: "variants.length > 0"
                              }
                            ],
                            staticClass: "half__nav half__nav--next icon-right",
                            attrs: { slot: "button-prev" },
                            slot: "button-prev"
                          })
                        ],
                        2
                      )
                    ],
                    1
                  )
                : _vm._e()
            ],
            1
          ),
          _c("br"),
          _c("template", { slot: "footer" }, [
            _c("div", { staticClass: "calendar__part" }, [
              _c("button", {
                staticClass: "calendar__link",
                staticStyle: { "margin-bottom": "0" },
                attrs: { type: "button", disabled: _vm.isLoading },
                domProps: {
                  textContent: _vm._s(
                    _vm.variants.length > 0 && _vm.replace
                      ? _vm.i18n.replace
                      : _vm.i18n.remove
                  )
                },
                on: {
                  click: function($event) {
                    return _vm.variantConfirm()
                  }
                }
              })
            ])
          ])
        ],
        2
      ),
      _c(
        "custom-modal",
        { ref: "loader", attrs: { dismissible: false } },
        [
          _c("loading", { attrs: { slot: "modalWindow" }, slot: "modalWindow" })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2cbbb654", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2cbbb654","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/js/calendar/components/stage-cell.vue
// module id = 247
// module chunks = 4